import React from 'react';
import styled from 'styled-components';
import { Points } from '@styles';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { SectionNumber } from '@components/Section-Number';
import { B2BCommand } from './organism/command';
import { B2BInfrastructure } from './organism/infrastructure';
import { B2BSlide } from './organism/slide';

export const B2B = () => {
  const translations = useTranslations();
  const slides = [
    {
      id: 1,
      img: '/images/home/b2b/ascona.svg',
      alt: translations.t('site.home.b2b.askona.alt'),
      title: translations.t('site.home.b2b.askona.name'),
      text: translations.t('site.home.b2b.askona.text'),
      link_text: translations.t('site.home.b2b.askona.link_text'),
      href: 'https://planoplan.com/ru/blog/interview/transformirovat-potrebitelskij-opyt-i-uvelichit-prodazhi-klientaskona/',
    },
    {
      id: 2,
      img: '/images/home/b2b/Angstrem.svg',
      alt: translations.t('site.home.b2b.angstrem.alt'),
      title: translations.t('site.home.b2b.angstrem.name'),
      text: translations.t('site.home.b2b.angstrem.text'),
      link_text: translations.t('site.home.b2b.angstrem.link_text'),
      href: 'https://planoplan.com/ru/blog/interview/mebelnyj-holding-angstrem/',
    },
    {
      id: 3,
      img: '/images/home/b2b/docrutim.svg',
      alt: translations.t('site.home.b2b.docrutim.alt'),
      title: translations.t('site.home.b2b.docrutim.name'),
      text: translations.t('site.home.b2b.docrutim.text'),
      link_text: translations.t('site.home.b2b.docrutim.link_text'),
      href: 'https://planoplan.com/ru/blog/interview/kak-3d-vizualizaciya-transformirovala-biznes-dokrutim/',
    },
  ];

  return (
    <View id="b2b">
      <Container>
        <Content>
          <SectionNumber number={''} text={translations.t('site.home.b2b.name')} />
          <Title>{translations.t('site.home.b2b.title')}</Title>
          <Caption>{translations.t('site.home.b2b.caption')}</Caption>

          <Slider>
            {slides.map((slide) => (
              <Slide key={slide.id}>
                <B2BSlide {...slide} />
              </Slide>
            ))}
          </Slider>

          <Bottom>
            <B2BCommand />
            <B2BInfrastructure />
          </Bottom>
        </Content>
      </Container>
    </View>
  );
};

const View = styled.section`
  height: auto;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: ${Colors.beige_100};
  position: relative;

  @media ${Points.tablet_landscape} {
    padding-bottom: 40px;
    padding-top: 40px;
  }

  @media ${Points.laptop_wide} {
    padding-top: 90px;
    padding-bottom: 80px;
  }
`;
const Container = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;
  display: flex;

  @media ${Points.tablet_landscape} {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    padding: 0 28px;
  }

  @media ${Points.laptop_wide} {
    ${Grid.prefix(2)};
    ${Grid.suffix(2)};
    width: 100%;
    max-width: 1600px;
  }
`;
const Content = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  @media ${Points.tablet_landscape} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
const Title = styled.div`
  font-size: 26px;
  line-height: 1;
  color: ${Colors.main_dark};
  margin-bottom: 15px;

  @media ${Points.tablet_portrait} {
    text-align: center;
  }

  @media ${Points.tablet_landscape} {
    font-size: 34px;
  }

  @media ${Points.laptop_wide} {
    font-size: 54px;
    margin-bottom: 20px;
  }
`;
const Caption = styled.div`
  font-size: 12px;
  line-height: 1;
  color: ${Colors.main_gray};
  max-width: 470px;

  @media ${Points.tablet_portrait} {
    margin: 0 auto;
    text-align: center;
  }

  @media ${Points.tablet_landscape} {
    text-align: center;
  }

  @media ${Points.laptop_wide} {
    font-size: 14px;
  }
`;
const Slider = styled.div`
  margin-top: 37px;
  display: flex;
  position: relative;
  display: flex;
  overflow: auto;
  margin-bottom: 16px;

  @media ${Points.tablet_landscape} {
    margin-top: 18px;
  }

  @media ${Points.laptop_wide} {
    margin-top: 40px;
  }
`;
const Slide = styled.div`
  min-width: 265px;
  max-width: 33.33%;

  &:not(:last-child) {
    margin-right: 16px;
  }
`;
const Bottom = styled.div`
  width: 100%;

  @media ${Points.tablet_portrait} {
    display: flex;
    gap: 16px;
  }

  @media ${Points.tablet_landscape} {
    display: flex;
    margin-top: 12;
  }
`;
